import { useEffect } from 'react';
import { onWeaveTokenChange } from '@frontend/auth-helpers';
import env from '@frontend/env';
import { ErrorBoundary } from '@frontend/error-boundary';
import { IpcShellProvider } from '@frontend/shell-utils';
import { siteNameSync } from '@frontend/site-name-sync';
import { requestUserPreferencesSync } from '@frontend/user-preferences';
import { ThemeProvider } from '@frontend/design-system';
import { App } from './app';
import { DebugModeProvider } from './providers/debug-provider';
import { NotificationManagerProvider } from './providers/notification-manager';

const notificationChannels = {
  stable: 'notification.getweave.com',
  edge: 'notification-edge.getweave.com',
  staging: 'notification-staging.getweave.com',
};

requestUserPreferencesSync();

const Root = () => {
  useEffect(() => {
    const syncSiteName = () => siteNameSync.init('notification', notificationChannels);
    syncSiteName();
    return onWeaveTokenChange(syncSiteName);
  }, []);

  console.log('Version: - ', env.VERSION);
  return (
    <ErrorBoundary
      tier='app'
      feature='notification.root'
      team='frontend-ops'
      fallback={() => {
        window.location.reload();
        return <>An Error Occurred</>;
      }}
    >
      <IpcShellProvider context='notifications'>
        <ThemeProvider includeEmotionTheme skipAnimation={false}>
          <DebugModeProvider>
            <NotificationManagerProvider>
              <App />
            </NotificationManagerProvider>
          </DebugModeProvider>
        </ThemeProvider>
      </IpcShellProvider>
    </ErrorBoundary>
  );
};

export default Root;
